export default __webpack_public_path__ + "images/11bb5ba0c54a097b75eaa5a5d0b57665.svg";